import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";

import Login from "./pages/Login";
import Layout from "./components/crm/Layout";
import AdminDashboard from "./pages/AdminDashboard";
import AgentDashboard from "./pages/AgentDashboard";
import LeadsList from "./pages/LeadsList";
import LeadDetail from "./pages/LeadDetail";
import Activities from "./pages/Activities";
import Calendar from "./pages/Calendar";
import ImportCSV from "./pages/ImportCSV";
import AgentsReport from "./pages/AgentsReport";
import Agents from "./pages/Agents";
import LeadMap from "./pages/LeadMap";
import Catalog from "./pages/Catalog";
import Settings from "./pages/Settings";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-500">
        Loading...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

function DashboardRoute() {
  const { user } = useAuth();
  return user?.role === "admin" ? <AdminDashboard /> : <AgentDashboard />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Protected><DashboardRoute /></Protected>} />
          <Route path="/leads" element={<Protected><LeadsList /></Protected>} />
          <Route path="/leads/:id" element={<Protected><LeadDetail /></Protected>} />
          <Route path="/activities" element={<Protected><Activities /></Protected>} />
          <Route path="/calendar" element={<Protected><Calendar /></Protected>} />
          <Route path="/catalog" element={<Protected><Catalog /></Protected>} />
          <Route path="/tasks" element={<Navigate to="/activities" replace />} />
          <Route path="/import" element={<Protected adminOnly><ImportCSV /></Protected>} />
          <Route path="/reports" element={<Protected adminOnly><AgentsReport /></Protected>} />
          <Route path="/map" element={<Protected adminOnly><LeadMap /></Protected>} />
          <Route path="/agents" element={<Protected adminOnly><Agents /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
